import { render, staticRenderFns } from "./TestsTab.vue?vue&type=template&id=7d12cec4&"
import script from "./TestsTab.vue?vue&type=script&lang=js&"
export * from "./TestsTab.vue?vue&type=script&lang=js&"
import style0 from "./TestsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestsTab.vue"
export default component.exports